import { IconMap } from "components/AppImageUploader";
import { UploadIconFailureAction, UploadIconSuccessAction } from "../actions/UploadIcon";
import { AppState } from "../state";

export function uploadIconSuccess(state: AppState, action: UploadIconSuccessAction): AppState {
    const { app } = action.payload;
    const appImagesMap = state.uploadedImages && state.uploadedImages[app.appId] ? state.uploadedImages[app.appId] : {};

    const iconMap: IconMap = {
        icon: app.icon,
        largeIcon: app.largeIcon,
        mediumIcon: app.mediumIcon,
        smallIcon: app.smallIcon
    };

    return {
        ...state,
        uploadedImages: {
            ...state.uploadedImages,
            [app.appId]: {
                ...appImagesMap,
                icon: iconMap
            }
        }
    };
}

export function uploadIconFailure(state: AppState, action: UploadIconFailureAction): AppState {
    const errorMap = { ...state.errorMap };
    errorMap[action.type] = action.payload.error;
    return { ...state, errorMap };
}
